<template>
  <v-container fluid>
    <v-card>
      <v-list v-if="items.length > 0"
              three-line>
        <template v-for="(item, index) in items">
          <v-list-tile
            :key="item.id"
            :to="{ name: 'event_regex_edit', params: { id: item.id }}"
            avatar
            ripple
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.id }}</v-list-tile-title>
              <v-list-tile-sub-title class="hidden-sm-and-down">{{ item.regex |truncate(150) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="hidden-sm-and-down">
                <v-chip color="red darken-1" text-color="white" v-if="item.customer === NULL">
                  IMWF
                </v-chip>   
                <v-chip color="red darken-1" text-color="white" v-else>
                  {{ item.customer }}
                </v-chip>                           
                <v-chip color="green darken-1" text-color="white" v-if="item.project === 'ALLGEMEIN'">
                  {{ item.project }}
                </v-chip>
                <v-chip color="grey darken-4" text-color="white" v-else>
                  {{ item.project }}
                </v-chip>
                <v-chip color="blue darken-4" text-color="white">
                  {{ item.event_type }}
                </v-chip>
                <v-chip color="red darken-4" text-color="white" v-if="item.is_inactive">
                  <v-avatar>
                    <v-icon>block</v-icon>
                  </v-avatar>
                  Inactive
                </v-chip>
              </v-list-tile-sub-title>
            </v-list-tile-content>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'

  export default {
    name: 'EventRegexHome',
    data() {
      return {
        selected: null,
        info: null,
        items: [],
        search: '',
        errored: false,
        loading: true,
      }
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + '...';
        }
        return value
      }
    },
    mounted() {
      this.$emit('TriggerLoading', true)

      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      axios.get(`${Config.API_URL}/event_regex`)
        .then(response => {
          // console.log(response);
          this.loading = false
          this.items = response.data.regexes
          this.$emit('TriggerLoading', false)
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.errored = true
        })
    },
  }
</script>
